module.exports = __webpack_public_path__ + "img/2.3fce2e90.png";